const contentful = require("contentful");
export const client = contentful.createClient({
  space: "k0d74helxbav",
  accessToken: "VHnZ1eWZqlDX5I-FawNqBkVh84V3x_mE_gkXWDz8lfI",
});
